<div class="container-fluid px-1 px-md-3">
    <div class="row">
        <div class="col-md-12 mb-3">
            <ng-content></ng-content>
        </div>
    </div>
</div>
